import React from "react";

/* Form & Form Validation */
import * as Yup from "yup";

import { Form, Input, Select, Switch, Checkbox } from "formik-antd";
import { Divider } from "antd";

import ModalForm from "../../../../../core/components/form/modalForm";

import {
    RESULT_TYPE_UNIT,
    FILTER_ENTITY_VENDOR,
    FILTER_ENTITY_CLIENT,
    FILTER_ENTITY_PROJECT,
    FILTER_ENTITY_POINT_OF_SALE,
    FILTER_ENTITY_COMPONENT,
    FILTER_ENTITY_MANAGER,
    getFilterEntitiesFor,
    getVariableTypeListFor,
} from "../../../../../config/consts/period";

const ValidationSchema = Yup.object().shape({
    variable_type: Yup.string().required("Cannot be blank."),
    entity: Yup.string().required("Cannot be blank."),
});

const _filter = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;

const Formulario = (props) => {
    const _initialForm = () => {
        return {
            result_type: props.result,
            variable_type: props.result === RESULT_TYPE_UNIT ? "Custom" : "",
            entity: "All",
            service: null,
            vendor: null,
            client: null,
            project: null,
            point_of_sale: null,
            component: null,
        };
    };

    return (
        <ModalForm
            loading={props.loading}
            title={"Add variables"}
            initialValues={_initialForm()}
            onCancel={props.handleCancel}
            validationSchema={ValidationSchema}
            onSubmit={props.handleSubmit}
            visible={props.visible}
            width={700}
            render={({ isSubmitting, setFieldValue, touched, errors, values }) => (
                <>
                    {values.result_type === RESULT_TYPE_UNIT && (
                        <Form.Item label="Service" name="service" hasFeedback={true} required>
                            <Select
                                placeholder="Service"
                                name="service"
                                showSearch
                                options={props.services}
                                filterOption={_filter}
                                showSearch
                                allowClear
                            />
                        </Form.Item>
                    )}

                    {values.result_type !== RESULT_TYPE_UNIT && (
                        <Form.Item
                            label="Type"
                            name="variable_type"
                            hasFeedback={true}
                            showValidateSuccess={true}
                            required
                        >
                            <Select
                                placeholder="Type"
                                name="variable_type"
                                showSearch
                                options={getVariableTypeListFor(values.result_type)}
                            />
                        </Form.Item>
                    )}

                    <Form.Item label="Entity" name="entity" hasFeedback={true} showValidateSuccess={true} required>
                        <Select
                            placeholder="Type"
                            name="entity"
                            showSearch
                            options={getFilterEntitiesFor(values.result_type, values.variable_type)}
                        />
                    </Form.Item>

                    {values.entity === FILTER_ENTITY_VENDOR && (
                        <Form.Item label="Vendor" name="vendor" hasFeedback={true} required>
                            <Select
                                placeholder="Vendor"
                                name="vendor"
                                showSearch
                                options={props.vendors}
                                filterOption={_filter}
                                showSearch
                                allowClear
                            />
                        </Form.Item>
                    )}

                    {values.entity === FILTER_ENTITY_MANAGER && (
                        <Form.Item label="Manager" name="manager" hasFeedback={true} required>
                            <Select
                                placeholder="Manager"
                                name="manager"
                                showSearch
                                options={props.managers}
                                filterOption={_filter}
                                showSearch
                                allowClear
                            />
                        </Form.Item>
                    )}

                    {values.entity === FILTER_ENTITY_CLIENT && (
                        <Form.Item label="Client" name="client" hasFeedback={true} required>
                            <Select
                                placeholder="Client"
                                name="client"
                                options={props.clients || []}
                                filterOption={_filter}
                                showSearch
                                allowClear
                            />
                        </Form.Item>
                    )}

                    {values.entity === FILTER_ENTITY_PROJECT && (
                        <Form.Item label="Project" name="project" hasFeedback={true} required>
                            <Select
                                placeholder="Project"
                                name="project"
                                showSearch
                                options={props.projects || []}
                                filterOption={_filter}
                                showSearch
                                allowClear
                            />
                        </Form.Item>
                    )}

                    {values.entity === FILTER_ENTITY_POINT_OF_SALE && (
                        <Form.Item label="Point of Sale" name="point_of_sale" hasFeedback={true} required>
                            <Select
                                placeholder="Point of Sale"
                                name="point_of_sale"
                                showSearch
                                options={props.pointsOfSale || []}
                                filterOption={_filter}
                                showSearch
                                allowClear
                            />
                        </Form.Item>
                    )}

                    {values.entity === FILTER_ENTITY_COMPONENT && (
                        <Form.Item label="Component" name="component" hasFeedback={true} required>
                            <Select
                                placeholder="Component"
                                name="component"
                                showSearch
                                options={props.components || []}
                                filterOption={_filter}
                                showSearch
                                allowClear
                            />
                        </Form.Item>
                    )}
                </>
            )}
        />
    );
};

export default Formulario;
